import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

/** Drop paginated host inventory cache after create/publish — never refetch GET_ALL_CARS. */
export function evictMyCarsV2Cache(
  client: ApolloClient<object> | ApolloClient<NormalizedCacheObject>,
): void {
  client.cache.evict({ fieldName: 'getMyCarsV2' });
  client.cache.gc();
}
